// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"350e135e","453":"7fed030f","455":"8a5065c3"}[chunkId] + ".chunk.js";
};